import request from '@/utils/request';
import { TableListParams } from './data.d';

export async function queryHosts(params: { count: number }) {
  return request('/api/hosts', {
    params,
  });
}

export async function addHost(params: TableListParams) {
  return request('/api/hosts', {
    method: 'POST',
    data: {
      ...params,
      method: 'post',
    },
  });
}

export async function updateHost(params: TableListParams) {
  const { id, ...restParams } = params;
  return request(`/api/hosts/${id}`, {
    method: 'POST',
    data: {
      ...restParams,
      method: 'update',
    },
  });
}
